var UtilPager = /** @class */ (function () {
    function UtilPager() {
        this.getPageItems = function (list, pageNumber, maxListItems) {
            return list.slice(pageNumber * maxListItems, (pageNumber + 1) * maxListItems);
        };
        this.getPageItemsNext = function (list, pageNumber) {
            return list.slice(pageNumber, pageNumber + 1);
        };
        this.getPageItemsFilled = function (list, pageNumber, maxListItems) {
            var firstItem = pageNumber * maxListItems;
            var lastItem = Math.min((pageNumber + 1) * maxListItems, list.length);
            return list.slice(firstItem, lastItem);
        };
    }
    return UtilPager;
}());
export var utilPager = new UtilPager();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilPager.ts
// module id = 302
// module chunks = 3